import { DialogComponent } from '@theme/dialog';

/**
 * Announcement dialog positioned just below its announcement row.
 */
class AnnouncementModalComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('resize', this.updatePosition);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.updatePosition);
    super.disconnectedCallback();
  }

  showDialog() {
    this.updatePosition();
    super.showDialog();
  }

  updatePosition = () => {
    const announcementBar = this.closest('.shavingart__announcement-bar');
    if (!announcementBar) return;

    const top = Math.max(12, announcementBar.getBoundingClientRect().bottom + 12);
    this.refs.dialog.style.setProperty('--announcement-modal-top', `${top}px`);
  };
}

if (!customElements.get('announcement-modal-component')) {
  customElements.define('announcement-modal-component', AnnouncementModalComponent);
}
